// @ts-nocheck
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";
 import { supabase } from '@/lib/supabase';
 
 interface RegistrationErrorDetails {
   email: string;
   role: string;
   errorMessage: string;
   errorCode?: string;
   firstName?: string;
   lastName?: string;
   step?: string;
   additionalContext?: Record<string, any>;
 }
 
 /**
  * Send an alert to admins when a registration fails
  * This helps catch and address registration issues proactively
  */
 export async function sendRegistrationFailureAlert(details: RegistrationErrorDetails): Promise<void> {
   try {
     console.log('[REGISTRATION-ALERT] Sending failure notification:', details);
     
     const { error } = await invokeEdgeFunction('send-error-alert', {
       body: {
         errorType: 'Registration Failure',
         errorMessage: details.errorMessage,
         errorStack: details.errorCode ? `Error Code: ${details.errorCode}` : undefined,
         userEmail: details.email,
         context: {
           role: details.role,
           firstName: details.firstName,
           lastName: details.lastName,
           step: details.step || 'unknown',
           ...details.additionalContext
         },
         timestamp: new Date().toISOString()
       }
     });
     
     if (error) {
       console.error('[REGISTRATION-ALERT] Failed to send alert:', error);
     } else {
       console.log('[REGISTRATION-ALERT] Alert sent successfully');
     }
   } catch (alertError) {
     // Don't let alert failures affect the user experience
     console.error('[REGISTRATION-ALERT] Exception sending alert:', alertError);
   }
 }